"use strict";

exports.__esModule = true;
exports.CreativeEventHandler = void 0;
var _XmlValidation2 = require("../Parsers/XmlValidation");
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/** CreativeEventHandler declares a set of methods that allow clients to provide event information to
 * a creative, industry icon or interactive creative.
 *
 * It is implemented by LinearCreative, NonLinearCreative, CompanionCreative, IndustryIcon and InteractiveCreative.
 * Clients <b>must</b> call each method at the appropriate time so that the SDK can signal analytics on behalf of the app.
 * @hideconstructor
 */
var CreativeEventHandler = /*#__PURE__*/function (_XmlValidation) {
  _inheritsLoose(CreativeEventHandler, _XmlValidation);
  function CreativeEventHandler() {
    return _XmlValidation.apply(this, arguments) || this;
  }
  var _proto = CreativeEventHandler.prototype;
  /**
   * Indicates that the user clicked on the element. If a clicktracking event is defined in the VAST
   * document for the Creative then the SDK will fire that tracking beacon.
   */
  _proto.onClickThrough = function onClickThrough() {
    throw new Error("Function must be overridden");
  }

  /** Indicates that a tracking event occurred for the element.
   *
   * If the event is defined in the `<Tracking>` element for the Creative then the SDK will fire that tracking beacon.<br/>
   * For a list of supported events, please refer to the Creative that implements this protocol.
   *
   * @param {string} event The tracking event name, or a tracking URL.
   */;
  _proto.onTrackingEvent = function onTrackingEvent(event) {
    throw new Error("Function must be overridden");
  }

  /** Defines whether the Creative is being presented to the user.
   * 
   * Tracking events are signalled for a creative only when it is visible. For a list of
   * supported events, please refer to the User Guide.
   * 
   * This method does not apply to Linear Creative, which are always visible.
   * @param {boolean} visible Describes whether the Creative is visible.
   */;
  _proto.setVisible = function setVisible(visible) {
    throw new Error("Function must be overridden");
  };
  return CreativeEventHandler;
}(_XmlValidation2.XmlValidation);
exports.CreativeEventHandler = CreativeEventHandler;